import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Boni" className="border-y border-grape/10 bg-white/70" data-id="element-16" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-5xl px-5 py-12" data-id="element-17" data-mp="authtb27n7y3">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="fteh989n1nlh">
          🎁 5 kostenlose Boni enthalten
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm text-plum/60" data-id="element-19" data-mp="1whrla59ac66">
          Zusätzlich zum Hauptbuch erhältst du auch diese Geschenke — ohne zusätzliche Kosten.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3o36bwmv8bejy">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex flex-col rounded-2xl border border-grape/20 bg-cream p-6" data-id="element-21" data-mp="3t181lqn5uc4e" data-mpi={i}>
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-22" data-mp="3df3bbshuznll">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-23" data-mp="3r68eh4kfqy0o">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-24" data-mp="3n7iugt4w6i82" /> Bonus {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-25" data-mp="2zhoj6g0811px">
                  <span className="text-plum/40 line-through" data-id="element-26" data-mp="2uhixdggmu9fr">{b.price}</span>{' '}
                  <span className="text-blush-deep" data-id="element-27" data-mp="38gs1vivh7f3w">KOSTENLOS</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-plum" data-id="element-28" data-mp="33gw6g80ugvzy">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-29" data-mp="nprjn758onkm">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-blush/40 bg-blush-soft p-6 text-center" data-id="element-30" data-mp="ipwub814461o">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-31" data-mp="3chv4fnymz8ll">
            💰 Gesamtwert der Boni: <span className="text-plum/50 line-through" data-id="element-32" data-mp="3hh80mzbeds0u">146€</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-33" data-mp="3ljl3nfyrfbtx">
              HEUTE KOSTENLOS MIT K-VISUAL MASTERPLAN™
            </span>
          </p>
        </div>
      </div>
    </section>;
}